/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendCapexDto } from '../../models/backend-capex-dto';
import { BackendCapexRequestDto } from '../../models/backend-capex-request-dto';

export interface EconomicIndicatorsCapexsUpdate$FormData$Params {
  /**
   * A unique integer value identifying this capex.
   */
  id: number;
  body?: BackendCapexRequestDto;
}

export function economicIndicatorsCapexsUpdate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: EconomicIndicatorsCapexsUpdate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendCapexDto>> {
  const rb = new RequestBuilder(rootUrl, economicIndicatorsCapexsUpdate$FormData.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendCapexDto>;
    }),
  );
}

economicIndicatorsCapexsUpdate$FormData.PATH = '/api/economic_indicators/capexs/{id}/';
